<template>
  <div class="page_title">회원 정보 입력</div>
  <div class="form_area">
    <form action="/welcome" method="" onsubmit="return formCheckJoin(this)">
      <input type="hidden" name="join_type" value="general" />

      <div class="nl_con">
        <div class="nl">
          <div class="nl_title">
            <p>이름</p>
            <span>*</span>
          </div>
          <div class="nl_input">
            <div class="input_cover">
              <input
                id="user_pw"
                type="text"
                class="input modify"
                name=""
                :value="userName"
                maxlength="20"
                readonly
              />
              <span class="user_id_span">본인 인증이 완료되었습니다.</span>
            </div>
          </div>
        </div>
        <div class="nl">
          <div class="nl_title">
            <p>아이디</p>
            <span>*</span>
          </div>
          <div class="nl_input">
            <div class="input_cover">
              <input
                id="user_id"
                v-model="enteredId"
                type="text"
                class="input modify wd_75 id_input on"
                name=""
                placeholder="5-12자 영문, 숫자 사용 가능"
                maxlength="12"
                @input="filterIDInput"
              />
              <span v-if="idlengthCheck" class="user_id_span">
                최소 5자 이상 입력이 필요합니다.
              </span>
            </div>
            <div
              class="btn_basic overlap_btn duplicate_check"
              attr-name="user_id"
              @click="checkDupID()"
            >
              중복확인
            </div>
          </div>
        </div>

        <div class="nl">
          <div class="nl_title">
            <p>비밀번호</p>
            <span>*</span>
          </div>
          <div class="nl_input">
            <div class="input_cover">
              <input
                id="user_pw"
                v-model="enteredPw"
                type="password"
                class="input modify"
                name=""
                placeholder="8자 이상 문자, 숫자, 기호 사용 가능"
                maxlength="20"
                @input="checkPWLength"
              />
              <span v-if="pwlengthCheck" class="user_id_span"
                >최소 8자 이상 입력이 필요합니다.</span
              >
            </div>
          </div>
        </div>

        <div class="nl">
          <div class="nl_title">
            <p>비밀번호 재입력</p>
            <span>*</span>
          </div>
          <div class="nl_input">
            <div class="input_cover">
              <input
                id="user_pw_ok"
                v-model="enteredPwChk"
                type="password"
                class="input modify"
                name=""
                placeholder="설정한 비밀번호를 다시 한번 입력해주세요."
                maxlength="20"
                @input="checkPWequal"
              />
              <span v-if="enteredPwChk && !pwEqualCheck" class="user_id_span">
                비밀번호가 일치하지 않습니다.
              </span>
              <span v-if="enteredPwChk && pwEqualCheck" class="user_id_span">
                비밀번호가 일치합니다.
              </span>
            </div>
          </div>
        </div>

        <div class="nl">
          <div class="nl_title">
            <p>휴대폰 번호</p>
            <span>*</span>
          </div>
          <div class="nl_input">
            <CustomSelectJoin
              :options="hp"
              defaultOption="010"
              @update:selected="handleSelect"
            />
            <input
              id="user_phone_2"
              v-model="initNum"
              type="text"
              class="input modify phone_2"
              name=""
              placeholder="1234-5678"
              oninput="hypenTel(this)"
              maxlength="9"
              required
            />
          </div>
        </div>

        <div class="nl">
          <div class="nl_title">
            <p>이메일</p>
            <span>*</span>
          </div>
          <div class="nl_input mail_input">
            <input
              id="user_email_1"
              v-model="emailID"
              type="email"
              class="input modify"
              name=""
              placeholder="이메일 계정"
              required
              @input="filterEmailIDInput"
            />
            <span class="whelk">@</span>
            <input
              v-if="showEmailInput"
              id="user_email_2"
              v-model="directEmailAdd"
              type="email"
              class="input modify"
              name=""
              placeholder="raoncorp.com"
              required
            />
            <CustomSelectJoin
              class="mailSelect"
              :options="email"
              defaultOption="선택하세요."
              @update:selected="handleSelectMail"
            />
          </div>
        </div>

        <div class="nl">
          <div class="nl_title">
            <p>마케팅</p>
            <span></span>
          </div>
          <div v-if="marketingSelected" class="nl_input">
            <div class="con_center">
              <input
                id="marketing_sms"
                v-model="sendSMS"
                type="checkbox"
                name="marketing"
              />
              <label for="marketing_sms"></label>
              <label for="marketing_sms" class="marketing_sms"
                >문자메시지</label
              >
            </div>
            <div class="con_center">
              <input
                id="marketing_email"
                v-model="sendEmail"
                type="checkbox"
                name="marketing"
              />
              <label for="marketing_email"></label>
              <label for="marketing_email" class="marketing_email"
                >이메일</label
              >
            </div>
          </div>
        </div>
      </div>

      <div class="btn_area">
        <div class="btn_basic join_cancel" @click="cancelJoin">취소</div>
        <input
          type="button"
          class="btn_orange gtm_join"
          value="회원가입"
          @click="createNewUser"
        />
      </div>
    </form>
  </div>
  <div class="Modals">
    <ModalAlertJoin
      :alertMsg="errMsg"
      :isOpen="errStatus"
      :endJoin="joinTrigger"
      :chkCancel="cancelTrigger"
      :chkID="IDTrigger"
      @update:isOpen="updateStatus"
    />
  </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue'
// import { useRouter } from 'vue-router'
import CustomSelectJoin from './CustomSelectJoin.vue'
import { checkDuplicationID, saveNewUserDatas } from '../api/join'
import ModalAlertJoin from './ModalAlertJoin.vue'

export default {
  name: 'JoinStepTwo',
  components: {
    CustomSelectJoin,
    ModalAlertJoin,
  },
  // setup() {
  setup() {
    const errMsg = ref('')
    const initNum = ref('')
    const errStatus = ref(false)
    const joinTrigger = ref('fail')
    const IDTrigger = ref('')
    const cancelTrigger = ref('')
    const userName = ref('')

    userName.value = localStorage.getItem('name')
    // const router = useRouter()
    const hp = ['010', '011', '016', '017', '019']
    const email = [
      'gamil.com',
      'naver.com',
      'hanmail.com',
      'hotmail.com',
      '직접입력',
    ]
    const enteredId = ref('')
    const uniqId = ref(false)
    const enteredPw = ref('')
    const enteredPwChk = ref('')
    const idlengthCheck = ref(false)
    const pwlengthCheck = ref(false)
    const pwEqualCheck = ref(false)

    const userPhoneNum = ref('')
    const emailID = ref('')
    const directEmailAdd = ref('')
    const userEmailAdd = ref('')
    const emailval = ref(false)
    const marketingSelected = localStorage.getItem('marketing')
    const sendSMS = ref(marketingSelected)
    const sendEmail = ref(marketingSelected)
    const getInfo = ref({
      userName: localStorage.getItem('name'),
      userBrith: localStorage.getItem('birth'),
      // userPhone: localStorage.getItem('phone'),
    })
    const phoneNumHeader = ref()
    const emailFooter = ref()

    // eslint-disable-next-line prefer-const
    initNum.value =
      getInfo.value.userPhone && getInfo.value.userPhone.length > 0
        ? getInfo.value.userPhone
            .slice(3, 11)
            .replace(/[^0-9]/g, '') // 숫자 이외의 문자는 제거
            .replace(/^(\d{3,4})(\d{4})$/, `$1-$2`) // 3자리 또는 4자리와 4자리 패턴으로 하이픈 추가
            .replace(/^(\d{3})(\d{4})$/, `$1-$2`) // 3자리와 4자리 패턴으로 하이픈 추가
        : '' // 기본 값으로 빈 문자열 할당

    const showEmailInput = ref(false)

    const filteringPhNum = () => {
      phoneNumHeader.value = phoneNumHeader.value || '010'
      userPhoneNum.value = phoneNumHeader.value + initNum.value.replace('-', '')
    }
    const checkEmailDatas = () => {
      if (emailID.value === '') {
        if (emailFooter.value === undefined) {
          emailval.value = false
          errMsg.value = '유효한 이메일 주소를 입력해 주세요.'
          errStatus.value = true
        } else {
          emailval.value = false
          errMsg.value = '이메일에 사용하실 주소를 선택해주세요.'
          errStatus.value = true
        }
      } else if (emailID.value !== '') {
        if (emailFooter.value === undefined) {
          emailval.value = false
          errMsg.value = '이메일에 사용하실 주소를 선택해 주세요.'
          errStatus.value = true
        } else if (emailFooter.value === '직접입력') {
          console.log('직접입력 진입')
          userEmailAdd.value = `${emailID.value}@${directEmailAdd.value}`
          emailval.value = true
        } else {
          userEmailAdd.value = `${emailID.value}@${emailFooter.value}`
          emailval.value = true
        }
      }
    }
    const handleSelect = (selected) => {
      phoneNumHeader.value = selected
      filteringPhNum()
    }

    const handleSelectMail = (selected) => {
      // alert(`선택된 값은: ${selected}`)
      emailFooter.value = selected
      showEmailInput.value = selected === '직접입력'
    }
    // const checkDupID = async () => {
    //   if (enteredId.value === '' || enteredId.value === null) {
    //     errMsg.value = '아이디를 입력해주세요'
    //     errStatus.value = true
    //   } else if (enteredId.value.length > 5) {
    //     const response = await checkDuplicationID(enteredId.value)
    //     if (response.code === 'MB11000200') {
    //       errMsg.value = '사용가능한 아이디 입니다.'
    //       uniqId.value = true
    //       errStatus.value = true
    //     } else if (response.code === 'MB11001400') {
    //       errMsg.value =
    //         '이미 존재하는 아이디 입니다. 다른 아이디로 시도해주세요.'
    //       uniqId.value = false
    //       errStatus.value = true
    //     }
    //   }
    // }
    const validateIdComplexity = (id) => {
      // 최소 5자, 하나 이상의 문자, 숫자를 포함하는 정규 표현식
      // const idRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{5,}$/
      const idRegex = /^(?![0-9]+$)(?!^[0-9])[A-Za-z][A-Za-z0-9]{4,11}$/
      return idRegex.test(id)
    }
    // eslint-disable-next-line consistent-return
    const checkDupID = async () => {
      const hasUpperCase = /[A-Z]/.test(enteredId.value)
      const startsWithNumber = /^[0-9]/.test(enteredId.value)

      if (enteredId.value === '' || enteredId.value === null) {
        IDTrigger.value = 'IdChkFaill'
        errMsg.value = '아이디를 입력해주세요'
        errStatus.value = true
        // } else if (hasUpperCase) {
        // 여기서 중복 체크를 중단할 필요가 없을 수 있음.
        // 계속해서 ID 유효성 체크를 진행할 수 있도록 return을 하지 않음.
        // // 대문자가 포함된 경우
        // IDTrigger.value = 'IdChkFaill'
        // errMsg.value = '영어 소문자를 사용해주세요.'
        // errStatus.value = true
        // return false // 중복 체크 중단
      } else if (startsWithNumber) {
        // 숫자로 시작하는 경우 경고 메시지 추가
        IDTrigger.value = 'IdChkFaill'
        errMsg.value =
          '아이디는 숫자로 시작할 수 없습니다. <br> 영어 소문자를 먼저 입력해주세요.'
        errStatus.value = true
        return false
      } else if (!validateIdComplexity(enteredId.value)) {
        IDTrigger.value = 'IdChkFaill'
        errMsg.value = '영어 소문자와 숫자 조합으로 구성해주세요.'
        errStatus.value = true
        return false
      } else if (enteredId.value.length > 5) {
        if (hasUpperCase) {
          // 대문자가 포함된 경우 소문자로 변환
          enteredId.value = enteredId.value.toLowerCase()
          // 여기서 중복 체크를 중단할 필요가 없을 수 있음.
          // 계속해서 ID 유효성 체크를 진행할 수 있도록 return을 하지 않음.
        }
        const response = await checkDuplicationID(enteredId.value)
        if (response.code === 'MB11000200') {
          IDTrigger.value = 'IdChkSuccess'
          errMsg.value = '사용가능한 아이디 입니다.'
          uniqId.value = true
          errStatus.value = true
        } else if (response.code === 'MB11001400') {
          IDTrigger.value = 'IdChkFaill'
          errMsg.value =
            '이미 존재하는 아이디 입니다. 다른 아이디로 시도해주세요.'
          uniqId.value = false
          errStatus.value = true
        }
      }
    }
    const checkIDLength = (enterData) => {
      idlengthCheck.value = enterData.length < 5
    }
    const checkPWLength = () => {
      pwlengthCheck.value = enteredPw.value.length < 8
    }
    const checkPWequal = () => {
      if (enteredPw.value === enteredPwChk.value) {
        pwEqualCheck.value = enteredPw.value === enteredPwChk.value
      } else {
        pwEqualCheck.value = enteredPw.value === enteredPwChk.value
      }
    }
    const filterIDInput = (event) => {
      const getId = event.target.value
      const filteredValue = getId.replace(/[^a-zA-Z0-9]/g, '')
      enteredId.value = filteredValue
      checkIDLength(filteredValue)
    }
    // const validateIdComplexity = (id) => {
    //   // 최소 5자, 하나 이상의 문자, 숫자를 포함하는 정규 표현식
    //   const idRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{5,}$/
    //   return idRegex.test(id)
    // }
    const filterEmailIDInput = (event) => {
      const getEmailId = event.target.value
      const filteredValue = getEmailId.replace(/[^a-zA-Z0-9]/g, '')
      emailID.value = filteredValue
    }
    const validatePasswordComplexity = (password) => {
      // 최소 8자, 하나 이상의 문자, 숫자, 특수문자를 포함하는 정규 표현식
      const passwordRegex =
        /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/
      return passwordRegex.test(password)
    }
    const validateInputs = () => {
      checkEmailDatas()
      if (!enteredId.value || enteredId.value.length < 5) {
        errMsg.value = '아이디는 5자 이상이어야 합니다.'
        errStatus.value = true
        return false
      }
      if (!uniqId.value) {
        errMsg.value = '아이디 중복체크를 진행해 주세요.'
        errStatus.value = true
        return false
      }
      if (!enteredPw.value || enteredPw.value.length < 8) {
        errMsg.value = '비밀번호는 8자 이상이어야 합니다.'
        errStatus.value = true
        return false
      }
      if (!validatePasswordComplexity(enteredPw.value)) {
        errMsg.value = '비밀번호는 문자, 숫자, 특수문자를 포함해야 합니다.'
        errStatus.value = true
        return false
      }
      if (enteredPw.value !== enteredPwChk.value) {
        errMsg.value = '비밀번호가 일치하지 않습니다.'
        errStatus.value = true
        return false
      }
      if (!userPhoneNum.value) {
        errMsg.value = '휴대폰 번호를 입력해 주세요.'
        errStatus.value = true
        return false
      }
      if (!emailval.value || !userEmailAdd.value) {
        errMsg.value = '유효한 이메일 주소를 입력해 주세요.'
        errStatus.value = true
        return false
      }
      return true
    }

    const createNewUser = async () => {
      if (!validateInputs()) return

      const userData = {
        userid: enteredId.value,
        password: enteredPw.value,
        password_confirm: enteredPwChk.value,
        phone: userPhoneNum.value,
        email: userEmailAdd.value,
        emailval: emailval.value,
        recv_sms: sendSMS.value,
        recv_email: sendEmail.value,
        idfc_id: localStorage.getItem('idfc_id'),
      }

      // console.log('유저 데이터:', userData)
      const response = await saveNewUserDatas(userData)

      // console.log('userData')
      // console.log(emailval.value)
      // console.log(response.value)
      // console.log(response)
      if (response.code === 'MB10000201') {
        errMsg.value = '회원가입에 성공하였습니다.'
        errStatus.value = true
        joinTrigger.value = 'success'
      } else if (response.code === 'MB10011404') {
        errMsg.value = '본인인증 유효시간이 초과되었습니다. 다시 시도해 주세요.'
        errStatus.value = true
        joinTrigger.value = 'authTimeOut'
        // eslint-disable-next-line no-dupe-else-if
      } else if (response.code === 'MB10000201') {
        errMsg.value =
          '시스템 오류가 발생했습니다. <br> 오류가 계속 발생하는 경우 서비스 이용 문의를 통해 관리자에게 문의해 주세요.'
        errStatus.value = true
        joinTrigger.value = 'systemErr'
      }
    }
    const updateStatus = () => {
      errStatus.value = false
    }
    const cancelJoin = () => {
      cancelTrigger.value = 'cancel'
      errMsg.value =
        '취소 시 작성 중인 내용은 사라집니다. <br> 취소하시겠습니까?'
      errStatus.value = true
    }

    onMounted(() => {
      filteringPhNum()
    })
    // initNum 감시
    watch(
      () => initNum.value,
      () => {
        filteringPhNum()
      }
    )

    // enteredPw 감시
    watch(
      () => enteredPw.value,
      (newPw) => {
        checkPWequal()
        if (enteredPwChk.value !== '' && newPw !== enteredPwChk.value) {
          pwEqualCheck.value = false
        } else if (enteredPwChk.value !== '' && newPw === enteredPwChk.value) {
          pwEqualCheck.value = true
        }
      }
    )

    return {
      errMsg,
      errStatus,
      joinTrigger,
      updateStatus,
      createNewUser,
      hp,
      email,
      handleSelect,
      handleSelectMail,
      showEmailInput,
      checkDupID,
      initNum,
      marketingSelected,
      sendSMS,
      sendEmail,
      enteredId,
      enteredPw,
      enteredPwChk,
      checkIDLength,
      checkPWLength,
      checkPWequal,
      idlengthCheck,
      pwlengthCheck,
      pwEqualCheck,

      emailID,
      directEmailAdd,
      userEmailAdd,

      filterIDInput,
      validateIdComplexity,
      filterEmailIDInput,
      filteringPhNum,
      checkEmailDatas,

      cancelJoin,
      cancelTrigger,

      IDTrigger,

      userName,
    }
  },
}
</script>

<style scoped>
/* 필요한 스타일을 여기에 추가하세요 */
</style>
